import { 
  PricingOutputBoundary, 
  PricingResponse 
} from '../types/PricingTypes';
import { 
  PricingViewModel, 
  PricingTierViewModel 
} from '../types/PricingViewModels';


export class PricingPresenter implements PricingOutputBoundary {
  constructor(
    private readonly updateView: (viewModel: PricingViewModel) => void
  ) {}


  public presentPricingConfiguration(response: PricingResponse): void {
    const tierViewModels: PricingTierViewModel[] = response.configuration
      .getTiersSortedByOrder()
      .map(tier => ({
        id: tier.id,
        name: tier.name,
        description: tier.description,
        features: tier.features,
        actionUrl: tier.actionUrl,
        actionText: tier.actionText,
        isBasicTier: tier.isBasicTier(),
        isPremiumTier: tier.isPremiumTier()
      }));


    const viewModel: PricingViewModel = {
      tiers: tierViewModels,
      loading: false,
      error: null,
      lastUpdated: this.formatDateTime(response.requestedAt)
    };


    this.updateView(viewModel);
  }


  public presentPricingError(error: string): void {
    const viewModel: PricingViewModel = {
      tiers: [],
      loading: false,
      error,
      lastUpdated: this.formatDateTime(new Date())
    };


    this.updateView(viewModel);
  }


  public presentLoadingState(): void {
    const viewModel: PricingViewModel = {
      tiers: [],
      loading: true,
      error: null,
      lastUpdated: ''
    };


    this.updateView(viewModel);
  }


  private formatDateTime(date: Date): string {
    return date.toLocaleString();
  }
}


